<!-- <head>
  <link href="https://unpkg.com/maplibre-gl@3.x/dist/maplibre-gl.css" rel="stylesheet" />
  <style>
    body {
      margin: 0;
    }

    #map {
      height: 100vh;
    }
  </style>
</head>

<body>
  <div id="map">
  <script src="https://unpkg.com/maplibre-gl@3.x/dist/maplibre-gl.js"></script>
  <script>
    const apiKey = "v1.public.eyJqdGkiOiI5YWE5M2IzZC04YzJiLTRmN2EtOTdiZi1lM2U4Y2VjZDdlNmMifY-CsFf09lpFoqmfVP5RNrfgBujnc_10Dj3L6UNokoG7iIfIc-atKXyTtGjsvFjyTvTZucDqshFuaQwjiqpJcYurZiZSljynClRnFynKcqOayP-7aq8syTBj7xHbbRkRq5DbWrLpXdYQK6-E_OBdEGDE89wT7S6pFHUSOdWzuBcXrTeA7OemFI5SIoD5JuLzHZzLsWcTmfvfzNCWMvS2VN57fpAu5yWLEilBpc3CYB1oiQmsLix8ugGlxSWx6RdoV6ZpyfqwgB0NbUKT2GJUKK8RB8s1pebBZF_0n7_rwMkGqmxgXgZT1g7xXsWI5O__wf9HjAxCsi05r5-JeyZTDqQ.ZTA0NDFlODYtNGY5Mi00NWU4LTk1MDgtMmY4YmViYWFhYjUz";
    const mapName = "e-transport";
    const region = "sa-east-1";

    const map = new maplibregl.Map({
      container: "map",
      style: `https://maps.geo.${region}.amazonaws.com/maps/v0/maps/${mapName}/style-descriptor?key=${apiKey}`,
      center: [-123.115898, 49.295868],
      zoom: 11,
    });
    map.addControl(new maplibregl.NavigationControl(), "top-left");
  </script>
</div>
</body> -->


<!-- <div id="map">
  <!-- Adicione o formulário dentro da div do mapa 
  <form>
    <input type="text" placeholder="Digite a placa" (input)="atualizarPlacaFiltrada($event)" [(ngModel)]="placaFiltrada" name="placaFiltrada">
  </form>
</div> -->

<div id="map">
  <!-- Adicione o formulário dentro da div do mapa -->
  <form>
    <div class="infoMapa">
      <span>Pesquisar: </span>
      <input class="procuraPlaca" type="text" placeholder="Digite a placa" (input)="atualizarPlacaFiltrada($event)"
        [(ngModel)]="placaFiltrada" name="placaFiltrada"><br>
      <!-- <input type="checkbox" [(ngModel)]="verVerdes" name="verVerdes"> Carros Verdes<br> -->
      <input type="checkbox" [(ngModel)]="verVerdes" (change)="handleChange()" name="verVerdes"> Veículos Verdes<br>
      <input type="checkbox" [(ngModel)]="verVermelhos" (change)="handleChange()" name="verVermelhos"> Veículos
      Vermelhos<br>
      <input type="checkbox" [(ngModel)]="verTCM" (change)="handleChange()" name="verTCM"> Veículos TCM<br>
      <input type="checkbox" [(ngModel)]="verJSL" (change)="handleChange()" name="verJSL"> Veículos JSL<br>
      <input type="checkbox" [(ngModel)]="verJSLARG" (change)="handleChange()" name="verJSLARG"> Veículos JSL-ARG<br>
      <input type="checkbox" [(ngModel)]="verLOTS" (change)="handleChange()" name="verLOTS"> Veículos LOTS<br>
      <input type="checkbox" [(ngModel)]="verSUZAN" (change)="handleChange()" name="verSUZAN"> Veículos SUZAN<br>
      <input type="checkbox" [(ngModel)]="verSESE" (change)="handleChange()" name="verSESE"> Veículos SESE<br>
      <input type="checkbox" [(ngModel)]="verLocais" (change)="handleChange()" name="verLocais"> Locais<br>
      <input type="checkbox" [(ngModel)]="verComSinal" (change)="handleChange()" name="verComSinal"> <i-feather name="zap" class="green-icon"></i-feather>  {{ carrosComSinal }} Rastreando<br>
      <input type="checkbox" [(ngModel)]="verSemSinal" (change)="handleChange()" name="verSemSinal"> <i-feather name="zap-off" class="vermelho-icon"></i-feather>  {{ carrosSemSinal }} Sem sinal<br>
      <!-- <input type="checkbox" [(ngModel)]="verNomeLocais" (change)="handleChange()" name="verNomeLocais"> Nome dos Locais<br> -->
      <!-- <input type="checkbox" [(ngModel)]="verJSL-ARG" (change)="handleChange()" name="verVermelhos"> Carros Vermelhos<br> -->
      
      <br>
      <span>Total de carros verdes no mapa: {{ carrosVerdes }}</span>
      <br>
      <br>
      <span>Total de carros vermelhos no mapa: {{ carrosVermelhos }}</span>
      <br>
      <br>
      <span *ngIf="carros">Total de carros: {{ carrosVerdes + carrosVermelhos }}</span>
      <br>
      <br>
    </div>
  </form>
</div>

<clr-modal *ngIf="dialogOpen" [(clrModalOpen)]="dialogOpen" [clrModalSize]="'sm'" class="dialog-container">
  <h3 class="modal-title">Detalhes</h3>
  <div class="modal-body">
    <form class="inputs">
      <table class="table2000">
        <tr class="flexEdit">
          <td>
            <label class="modal-label">Transportadora</label>
          </td>
          <td class="align-left input-maior">
            <input type="text" name="transportadora" [(ngModel)]="item.transportadora" class="modal-input1">
            <!-- <input type="text" name="ID" [(ngModel)]="item.ID" class="modal-input1"> -->
          </td>
          <td>
            <label class="modal-label">Placa</label>
          </td>
          <td class="align-left input-maior">
            <input type="text" name="Plate" [(ngModel)]="item.Plate" class="modal-input1">
          </td>
          <td>
            <label class="modal-label">Volumes</label>
          </td>
          <td class="align-left input-maior">
            <input type="text" name="Volumes" [(ngModel)]="item.Volumes" class="modal-input1">
          </td>
        </tr>
        <tr *ngIf="item.Fornecedor1" class="flexEdit">
          <td>
            <label class="modal-label">Fornecedor 1</label>
          </td>
          <td class="align-left input-maior">
            <input type="text" name="Fornecedor1" [(ngModel)]="item.Fornecedor1" class="modal-input1">
          </td>
          <td>
            <label class="modal-label">Janela 1</label>
          </td>
          <td class="align-left input-maior">
            <input type="date" name="dataJanela1" [(ngModel)]="item.dataJanela1" class="modal-input1">
            <input type="time" name="horaJanela1" [(ngModel)]="item.horaJanela1" class="modal-input1">
          </td>
        </tr>
        <tr *ngIf="item.Fornecedor2" class="flexEdit">
          <td>
            <label class="modal-label">Fornecedor 2</label>
          </td>
          <td class="align-left input-maior">
            <input type="text" name="Fornecedor2" [(ngModel)]="item.Fornecedor2" class="modal-input1">
          </td>
          <td>
            <label class="modal-label">Janela 2</label>
          </td>
          <td class="align-left input-maior">
            <input type="date" name="dataJanela2" [(ngModel)]="item.dataJanela2" class="modal-input1">
            <input type="time" name="horaJanela2" [(ngModel)]="item.horaJanela2" class="modal-input1">
          </td>
        </tr>
        <tr *ngIf="item.Fornecedor3" class="flexEdit">
          <td>
            <label class="modal-label">Fornecedor 3</label>
          </td>
          <td class="align-left input-maior">
            <input type="text" name="Fornecedor3" [(ngModel)]="item.Fornecedor3" class="modal-input1">
          </td>
          <td>
            <label class="modal-label">Janela 3</label>
          </td>
          <td class="align-left input-maior">
            <input type="date" name="dataJanela3" [(ngModel)]="item.dataJanela3" class="modal-input1">
            <input type="time" name="horaJanela3" [(ngModel)]="item.horaJanela3" class="modal-input1">
          </td>
        </tr>
        <tr *ngIf="item.Fornecedor4" class="flexEdit">
          <td>
            <label class="modal-label">Fornecedor 4</label>
          </td>
          <td class="align-left input-maior">
            <input type="text" name="Fornecedor4" [(ngModel)]="item.Fornecedor4" class="modal-input1">
          </td>
          <td>
            <label class="modal-label">Janela 4</label>
          </td>
          <td class="align-left input-maior">
            <input type="date" name="dataJanela4" [(ngModel)]="item.dataJanela4" class="modal-input1">
            <input type="time" name="horaJanela4" [(ngModel)]="item.horaJanela4" class="modal-input1">
          </td>
        </tr>
      </table>
      <table class="table2000">
        <tr *ngIf="item.Destino1" class="flexEdit">
          <td>
            <label class="modal-label">Destino 1</label>
          </td>
          <td class="align-left input-maior">
            <input type="text" name="Destino1" [(ngModel)]="item.Destino1" class="modal-input1">
          </td>
          <td>
            <label class="modal-label">JanelaDestino 1</label>
          </td>
          <td class="align-left input-maior">
            <input type="date" name="dataJanelaDestino1" [(ngModel)]="item.dataJanelaDestino1" class="modal-input1">
            <input type="time" name="horaJanelaDestino1" [(ngModel)]="item.horaJanelaDestino1" class="modal-input1">
          </td>
        </tr>
        <tr *ngIf="item.Destino2" class="flexEdit">
          <td>
            <label class="modal-label">Destino 2</label>
          </td>
          <td class="align-left input-maior">
            <input type="text" name="Destino2" [(ngModel)]="item.Destino2" class="modal-input1">
          </td>
          <td>
            <label class="modal-label">JanelaDestino 2</label>
          </td>
          <td class="align-left input-maior">
            <input type="date" name="dataJanelaDestino2" [(ngModel)]="item.dataJanelaDestino2" class="modal-input1">
            <input type="time" name="horaJanelaDestino2" [(ngModel)]="item.horaJanelaDestino2" class="modal-input1">
          </td>
        </tr>
      </table>
      <table *ngIf="item.nextPoint != 'sem next Point'" class="table2000">
        <tr class="flexEdit infoNext">
          <td>
            <label class="modal-label">Próximo ponto: </label>
          </td>
          <td class="align-left input-maior">
            <!-- <input type="text" name="nextPoint" [(ngModel)]="item.nextPoint" class="modal-input1"> -->
            <span class="infoNext">{{ item.nextPoint }}</span>
          </td>
          <td>
            <label class="modal-label">Distância: </label>
          </td>
          <td class="align-left input-maior">
            <!-- <input type="text" name="distanceNextPoint" [(ngModel)]="item.distanceNextPoint" class="modal-input1"> -->
            <span class="infoNext">{{ item.distanceNextPoint | number:'1.2-2' }}</span>
          </td>
          <td>
            <label class="modal-label">Previsão: </label>
          </td>
          <td class="align-left input-maior">
            <!-- <input type="text" name="prevChegada" [(ngModel)]="item.prevChegada" class="modal-input1"> -->
            <span class="infoNext">{{ item.prevChegada | date : 'short' : '' : 'pt-BR' }}</span>
          </td>
        </tr>
      </table>
      <div class="modal-div botoes">
        <button class="modal-button" type="button" (click)="salvar()">Save</button>
        <button class="modal-button" type="button" (click)="cancel()">Cancel</button>
        <!-- <button [disabled]="isCarrierEnabled" class="modal-button" type="button"
                  (click)="deleteItem(item)">Delete</button> -->
      </div>
    </form>
  </div>
</clr-modal>

<div *ngIf="isLoading" class="spinner-overlay">
  <div class="spinner">
    <mat-spinner></mat-spinner>
  </div>
</div>